module.exports = __webpack_public_path__ + "img/TAPON MARCO.a06211b2.jpg";